import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  preview: false,
  previewObject: null,
  previewTemplateObject: null,
  previewPlaylistObject: null,
};

const previewSlice = createSlice({
  name: "preview",
  initialState,
  reducers: {
    setpreview: (state, action) => {
      state.preview = action.payload;
    },
    setpreviewObject: (state, action) => {
      state.previewObject = action.payload;
    },
    setpreviewTemplateObject: (state, action) => {
      state.previewTemplateObject = action.payload;
    },
    setpreviewPlaylistObject: (state, action) => {
      state.previewPlaylistObject = action.payload;
    },
    setpreviewLogout: (state, action) => {
      state.preview = false;
      state.previewObject = null;
      state.previewTemplateObject = null;
      state.previewPlaylistObject = null;
    },
  },
});

export const {
  setpreview,
  setpreviewLogout,
  setpreviewObject,
  setpreviewTemplateObject,
  setpreviewPlaylistObject,
} = previewSlice.actions;

export default previewSlice.reducer;
